module.exports = __webpack_public_path__ + "static/img/アセット 58@3x.ac9aa11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 58@3x.png
// module id = F9/z
// module chunks = 1